import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import OTPInput from 'react-otp-input';

const PayoutBank = (props) => {
  const [search, setSearch] = useState({
    page: 1,
    limit: 10,
  });
  const [data, setData] = useState([]);
  const [history, setHistory] = useState([]);
  const [isFetching, setIsFetching] = useState(true);
  const [rowcount, setRowcount] = useState(0);
  const columns = [
    {
      dataIndex: 'bankName',
      title: 'Bank Name',
      render: (text) => {
        return <h6 className="text-primary">{_enum.PAYOUT_BANKS_MAP[text]}</h6>;
      },
    },
    {
      dataIndex: 'createdAt',
      title: 'Updated On',
      render: (text, record) => {
        let date = new Date(text).dateToDDMMYYYY(new Date(text));
        if (record?.createdAt) {
          return date;
        } else {
          return '-';
        }
      },
    },
    {
      dataIndex: 'isActive',
      title: 'Status',
      render: (text, record) => {
        let isActive = record?.isActive;
        return (
          <span className={`badge light badge-${isActive ? 'success' : 'danger'}`}>
            {isActive ? 'Active' : 'Inactive'}
          </span>
        );
      },
    },
  ];
  const [showModal, setShowModal] = useState(false);
  const [isOtpDisabled, setIsOtpDisabled] = useState(true);
  const [showOTPInput, setShowOTPInput] = useState(false);
  const [otpValue, setOtpValue] = useState('');
  const [activeBankName, setActiveBankName] = useState('');

  const onPageChange = (pageData) => {
    setSearch((prevState) => ({
      ...prevState,
      page: pageData.current,
      limit: pageData.pageSize || pageData.defaultPageSize || 25,
    }));
  };

  const getActivePayoutBanks = () => {
    let payload = {
      ...search,
    };
    props.apis.apiGetCurrentActivePayoutBank(payload).then(({ data, total }) => {
      setData(data);
      setIsFetching(false);
      setRowcount(total);
    });
  };

  const getHistory = () => {
    props.apis.apiGetPayoutBankHistory().then(({ data }) => {
      setHistory(data);
    });
  }

  const edit = (record) => {
    openModal();
  };

  const openModal = () => setShowModal(true);
  const closeModal = () => {
    setShowOTPInput(false);
    setOtpValue('');
    setIsOtpDisabled(true);
    setShowModal(false);
  };

  const handleGenerateOTP = (e, data) => {
    e.preventDefault();
    e.stopPropagation();
    setActiveBankName(data.bankName)
    props.apis.apiGenerateOtpForUpdatingPayoutBank().then((res) => {
      if (res?.data?.status === 200) {
        toast.success(res?.message || 'OTP Generated Successfully!!');
        setShowOTPInput(true);
      }
    });
  };

  const handleOTPChange = (otp) => {
    setOtpValue(otp);
    if (otp.length === 6) {
      setIsOtpDisabled(false);
    } else {
      setIsOtpDisabled(true);
    }
  };

  const handleOtpVerify = (e) => {
    let payload = {
      bankName: activeBankName,
      otpCode: otpValue,
    };
    props.apis.apiUpdateActivePayoutBank(payload).then((res) => {
      closeModal();
    });
  };

  useEffect(() => {
    getActivePayoutBanks();
    getHistory();
  }, [search]);

  return (
    <>
      <AppTable
        data={data}
        columns={columns}
        onChange={(...arg) => onPageChange(...arg)}
        total={rowcount}
        reorder={true}
        editAction={(...args) => edit(...args)}
        viewable={false}
        deletable={false}
        loading={isFetching}
        showPagination={false}
      ></AppTable>

      {/* HISTORY */}
      <div className="mt-5">
        <h2 className="text-primary fs-5">History</h2>
      <AppTable
        data={history}
        columns={columns}
        onChange={(...arg) => onPageChange(...arg)}
        total={rowcount}
        reorder={true}
        editable={false}
        viewable={false}
        deletable={false}
        loading={isFetching}
        showPagination={false}
      ></AppTable>
      </div>

      {/* MODAL */}
      <Modal
        show={showModal}
        onHide={closeModal}
        centered
        backdrop="static"
        className="consent_otp_modal"
      >
        <Modal.Header closeButton className="border-0 py-4 d-flex align-item-start">
          <h2 className="fs-3">Edit Bank Name</h2>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <div className="row g-3 mb-4">
            <AppForm onSubmit={handleGenerateOTP} className="mt-0">
              <AppInput
                type="select"
                options={_enum.PAYOUT_BANKS}
                name="bankName"
                label="Bank Name"
              />
              {!showOTPInput ? (
                <div className="col-12">
                  <button type="submit" className="btn btn-primary w-100 py-3 mb-3">
                    Save
                  </button>
                  <button
                    type="button"
                    className="btn text-primary w-100 py-3"
                    onClick={(e) => closeModal()}
                  >
                    Cancel
                  </button>
                </div>
              ) : (
                <>
                  <hr />
                </>
              )}
            </AppForm>
            {showOTPInput && (
              <>
                <div className="col-12 d-flex flex-column">
                  <div className="">
                    <h3 className="">OTP to verify</h3>
                    <p className="">We have sent an OTP please verify</p>
                  </div>
                  <div className="d-flex mb-4">
                    <OTPInput
                      value={otpValue}
                      onChange={(e) => handleOTPChange(e)}
                      separator={<span>-</span>}
                      renderInput={(props) => <input {...props} />}
                      numInputs={6}
                      shouldAutoFocus={true}
                      isInputNum={true}
                      containerStyle="otp_container small p-0"
                    />
                  </div>
                  <div className="col-12">
                    <button
                      type="submit"
                      className="btn btn-primary w-100 py-3 mb-3"
                      onClick={(...args) => handleOtpVerify(...args)}
                      disabled={isOtpDisabled}
                    >
                      Submit
                    </button>
                    <button
                      type="button"
                      className="btn text-primary w-100 py-3"
                      onClick={(e) => closeModal()}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
                {/* <div className="col-12">
                  <div className="text-start otp_bottom">
                    <span className="me-2">Not received OTP?</span>
                    <button
                      className="btn px-0 text-primary fs-5 border-0"
                      disabled={isOtpDisabled}
                      onClick={(e) => resendOTP(e)}
                    >
                      Resend
                    </button>
                  </div>
                </div> */}
              </>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default constore(PayoutBank);
